module.exports = __webpack_public_path__ + "static/media/2.411606a6.jpg";